<template>
  <svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <path :fill="color" d="M23.11,72.68v-4.35c0-.77.63-1.4,1.4-1.4h50.97c.77,0,1.4.63,1.4,1.4v4.35c0,.77-.63,1.4-1.4,1.4H24.51c-.77,0-1.4-.63-1.4-1.4ZM23.11,58.92v-4.35c0-.77.63-1.4,1.4-1.4h50.97c.77,0,1.4.63,1.4,1.4v4.35c0,.77-.63,1.4-1.4,1.4H24.51c-.77,0-1.4-.63-1.4-1.4ZM23.11,44.25v-5.09c0-.49.25-.94.67-1.2l18.82-11.5c.48-.29,1.09-.27,1.55.06l15.03,10.73c.49.35,1.14.35,1.63,0l13.87-9.84c.93-.66,2.21,0,2.21,1.14v5.36c0,.46-.22.88-.59,1.14l-15.5,10.97c-.48.34-1.13.34-1.62,0l-15.39-10.86c-.46-.32-1.06-.34-1.54-.05l-17.01,10.32c-.93.57-2.13-.11-2.13-1.2Z"/>
  </svg>
</template>

<script>
export default {
  name: 'MetricsIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }

}
</script>

<style>

</style>
